import { render } from "./Bonus_setting.vue?vue&type=template&id=0cfd53b2"
import script from "./Bonus_setting.vue?vue&type=script&lang=js"
export * from "./Bonus_setting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__